<template>
  <div class="sample-dailog dialog">
    <div class="title">
      <h1>上傳樣本資訊</h1>
    </div>
    <div class="content container">
      <div class="row">
        <div class="col-12">
          <div class="buttons container">
            <input v-show="false"
              type="file"
              id="import"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              extension="xlsx"
              @change="e => fileTypeCheck(e, e => importFileOnChange(e), (e, ea) => addToast('error', '檔案格式有誤，請上傳' + ea.join('/')))">
            <input type="text" v-show="false" name="import" v-model="sampleFile" v-validate="'required'">
            <div class="mask">
              <label for="import" class="mask" />
              <button class="main-button field-button">
                <span><invisible :size="1" :isFullWidth="true" />匯入樣本資訊<invisible :size="1" :isFullWidth="true" /></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="sampleFile">
        <div class="col-12">
          <table class="table-line">
            <tr>
              <th>
                <center :style="{ width: '100%' }">匯入檔案</center>
              </th>
            </tr>
            <tr>
              <td>
                <center :style="{ width: '100%' }">{{ sampleFile.name }}</center>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="buttons container">
            <button class="main-button field-button" :class="{ 'loading': onSubmit }" :disabled="disabled" @click="validateImportSample()">
              <span><invisible :size="1" :isFullWidth="true" />上傳<invisible :size="1" :isFullWidth="true" /></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { postImportExtractionSample } from '../../api'
import invisible from '../tool/invisible'
import toastMethods from '../../mixins/toastMethods'
import { fileTypeCheck } from '../../constants/global/util.js'

export default {
  components: {
    invisible
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      sampleFile: '',
      onSubmit: false
    }
  },
  computed: {
    disabled () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.onSubmit) {
        value = true
      }
      return value
    },
    // util
    fileTypeCheck: () => fileTypeCheck
  },
  methods: {
    async importFileOnChange (e) {
      this.sampleFile = e.target.files[0]
      e.target.value = ''
    },
    async validateImportSample () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        await this.importSample()
      } else {
        this.addToast('error', '請先匯入檔案')
        this.onSubmit = false
      }
    },
    async importSample () {
      try {
        let config = this.$ls.get('userInfo') || {}
        let id = this.param.id
        let file = this.sampleFile
        await postImportExtractionSample(id, file, config)
        this.addToast('success', '上傳成功')
        this.onSubmit = false
        this.$emit('changeModal', {}, true)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.onSubmit = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/sample.vue